const Laptop = (props) => (
  <g {...props}>
    <defs>
      <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="a">
        <stop offset="0%" />
        <stop stop-color="#121212" offset="25.311%" />
        <stop stop-color="#121212" offset="78.133%" />
        <stop offset="100%" />
      </linearGradient>
      <path id="b" d="M82.403 19.657h95.932l5.165 14.497H76.99z" />
      <filter x="-.9%" y="-6.9%" width="101.9%" height="113.8%" filterUnits="objectBoundingBox" id="c">
        <feGaussianBlur stdDeviation=".5" in="SourceAlpha" result="shadowBlurInner1" />
        <feOffset dy="1" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.108440897 0" in="shadowInnerInner1" />
      </filter>
      <path id="d" d="M15.99 0h203.177l15.743 16.71H0z" />
      <filter x="-.4%" y="-6%" width="100.9%" height="112%" filterUnits="objectBoundingBox" id="e">
        <feGaussianBlur stdDeviation=".5" in="SourceAlpha" result="shadowBlurInner1" />
        <feOffset dy="1" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.098363904 0" in="shadowInnerInner1" />
      </filter>
      <path id="g" d="M70.842 13.27h77.237l.737 3.193H69.612z" />
      <filter x="-2.5%" y="-31.3%" width="105.1%" height="225.2%" filterUnits="objectBoundingBox" id="f">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="i" d="M149.35 13.27h18.482l1.156 3.193h-18.94z" />
      <filter x="-10.2%" y="-31.3%" width="120.4%" height="225.2%" filterUnits="objectBoundingBox" id="h">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="k" d="M169.028 13.27h14.56l1.388 3.193h-14.67z" />
      <filter x="-12.5%" y="-31.3%" width="125.1%" height="225.2%" filterUnits="objectBoundingBox" id="j">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="m" d="M184.77 13.27h14.316l2.125 3.193h-14.915z" />
      <filter x="-12.2%" y="-31.3%" width="124.3%" height="225.2%" filterUnits="objectBoundingBox" id="l">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="o" d="M200.268 13.27h14.56l2.372 3.193h-14.916z" />
      <filter x="-11.8%" y="-31.3%" width="123.6%" height="225.2%" filterUnits="objectBoundingBox" id="n">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="q" d="M215.764 13.27h14.56l2.864 3.193h-14.916z" />
      <filter x="-11.5%" y="-31.3%" width="123%" height="225.2%" filterUnits="objectBoundingBox" id="p">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="s" d="M194.324 10.32h33.25l2.663 2.703h-34.223z" />
      <filter x="-5.6%" y="-37%" width="111.1%" height="248%" filterUnits="objectBoundingBox" id="r">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="u" d="M179.073 10.32h14.12l1.623 2.703h-14.533z" />
      <filter x="-12.7%" y="-37%" width="125.4%" height="248%" filterUnits="objectBoundingBox" id="t">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="w" d="M163.822 10.32h14.12l1.13 2.703h-14.286z" />
      <filter x="-13.1%" y="-37%" width="126.2%" height="248%" filterUnits="objectBoundingBox" id="v">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="y" d="M148.57 10.32h14.12l.886 2.703h-14.533z" />
      <filter x="-13.3%" y="-37%" width="126.7%" height="248%" filterUnits="objectBoundingBox" id="x">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="A" d="M133.32 10.32h13.875l.638 2.703h-14.286z" />
      <filter x="-13.8%" y="-37%" width="127.6%" height="248%" filterUnits="objectBoundingBox" id="z">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="C" d="M118.07 10.32h13.874l.393 2.703H118.05z" />
      <filter x="-14%" y="-37%" width="128%" height="248%" filterUnits="objectBoundingBox" id="B">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="E" d="M102.573 10.32h14.12l.147 2.703h-14.533z" />
      <filter x="-13.8%" y="-37%" width="127.5%" height="248%" filterUnits="objectBoundingBox" id="D">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="G" d="M87.323 10.32h14.12l-.1 2.703H86.565z" />
      <filter x="-13.4%" y="-37%" width="126.9%" height="248%" filterUnits="objectBoundingBox" id="F">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="I" d="M72.072 10.32h14.12l-.837 2.703H71.068z" />
      <filter x="-13.2%" y="-37%" width="126.4%" height="248%" filterUnits="objectBoundingBox" id="H">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="K" d="M56.82 10.32h13.875l-.837 2.703H55.325z" />
      <filter x="-13%" y="-37%" width="126%" height="248%" filterUnits="objectBoundingBox" id="J">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="M" d="M41.57 10.32h13.874l-1.083 2.703H39.83z" />
      <filter x="-12.8%" y="-37%" width="125.6%" height="248%" filterUnits="objectBoundingBox" id="L">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="O" d="M7.133 10.32h33.06l-1.574 2.703H4.652z" />
      <filter x="-5.6%" y="-37%" width="111.3%" height="248%" filterUnits="objectBoundingBox" id="N">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="Q" d="M9.84 7.126h25.335l-2.067 2.948H7.358z" />
      <filter x="-7.2%" y="-33.9%" width="114.4%" height="235.7%" filterUnits="objectBoundingBox" id="P">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="S" d="M12.79 4.177H33.7L31.63 6.88h-21.32z" />
      <filter x="-8.6%" y="-37%" width="117.1%" height="248%" filterUnits="objectBoundingBox" id="R">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="U" d="M36.16 7.126h13.774l-1.575 2.948H34.17z" />
      <filter x="-12.7%" y="-33.9%" width="125.4%" height="235.7%" filterUnits="objectBoundingBox" id="T">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="W" d="M34.683 4.177h13.283L46.39 6.88H32.696z" />
      <filter x="-13.1%" y="-37%" width="126.2%" height="248%" filterUnits="objectBoundingBox" id="V">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="Y" d="M48.95 4.177h13.53L61.15 6.88H47.454z" />
      <filter x="-13.3%" y="-37%" width="126.6%" height="248%" filterUnits="objectBoundingBox" id="X">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aa" d="M63.71 4.177h13.28l-.836 2.703H62.46z" />
      <filter x="-13.8%" y="-37%" width="127.5%" height="248%" filterUnits="objectBoundingBox" id="Z">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ac" d="M78.22 4.177h13.284l-.59 2.703H77.216z" />
      <filter x="-14%" y="-37%" width="128%" height="248%" filterUnits="objectBoundingBox" id="ab">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ae" d="M92.734 4.177h13.283l-.1 2.703H92.223z" />
      <filter x="-14.5%" y="-37%" width="129%" height="248%" filterUnits="objectBoundingBox" id="ad">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ag" d="M107 4.177h13.776l-.1 2.703h-13.695z" />
      <filter x="-14.5%" y="-37%" width="129%" height="248%" filterUnits="objectBoundingBox" id="af">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ai" d="M121.76 4.177h13.283l.392 2.703H121.74z" />
      <filter x="-14.6%" y="-37%" width="129.2%" height="248%" filterUnits="objectBoundingBox" id="ah">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ak" d="M136.026 4.177h13.53l.638 2.703h-13.696z" />
      <filter x="-14.1%" y="-37%" width="128.2%" height="248%" filterUnits="objectBoundingBox" id="aj">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="am" d="M150.785 4.177h13.283l1.13 2.703h-13.695z" />
      <filter x="-13.9%" y="-37%" width="127.8%" height="248%" filterUnits="objectBoundingBox" id="al">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ao" d="M165.298 4.177h13.283l1.624 2.703h-13.696z" />
      <filter x="-13.4%" y="-37%" width="126.8%" height="248%" filterUnits="objectBoundingBox" id="an">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aq" d="M179.565 4.177h13.53l1.867 2.703h-13.696z" />
      <filter x="-13%" y="-37%" width="126%" height="248%" filterUnits="objectBoundingBox" id="ap">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="as" d="M194.324 4.177h13.528l1.87 2.703h-13.697z" />
      <filter x="-13%" y="-37%" width="126%" height="248%" filterUnits="objectBoundingBox" id="ar">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="au" d="M208.836 4.177h13.53l2.36 2.703h-14.188z" />
      <filter x="-12.6%" y="-37%" width="125.2%" height="248%" filterUnits="objectBoundingBox" id="at">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aw" d="M199.243 1.474h20.662l2.115 2.457h-20.81z" />
      <filter x="-8.8%" y="-40.7%" width="117.6%" height="262.8%" filterUnits="objectBoundingBox" id="av">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ay" d="M185.222 1.474h13.037l1.868 2.457h-13.184z" />
      <filter x="-13.4%" y="-40.7%" width="126.8%" height="262.8%" filterUnits="objectBoundingBox" id="ax">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aA" d="M171.202 1.474h12.79l1.623 2.457H172.43z" />
      <filter x="-13.9%" y="-40.7%" width="127.8%" height="262.8%" filterUnits="objectBoundingBox" id="az">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aC" d="M156.935 1.474h12.79l1.377 2.457h-13.43z" />
      <filter x="-14.1%" y="-40.7%" width="128.2%" height="262.8%" filterUnits="objectBoundingBox" id="aB">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aE" d="M142.914 1.474h13.037l.64 2.457h-13.43z" />
      <filter x="-14.6%" y="-40.7%" width="129.2%" height="262.8%" filterUnits="objectBoundingBox" id="aD">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aG" d="M128.647 1.474h13.037l.64 2.457h-13.677z" />
      <filter x="-14.6%" y="-40.7%" width="129.2%" height="262.8%" filterUnits="objectBoundingBox" id="aF">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aI" d="M114.38 1.474h13.283l-.1 2.457H114.38z" />
      <filter x="-15.1%" y="-40.7%" width="130.1%" height="262.8%" filterUnits="objectBoundingBox" id="aH">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aK" d="M100.114 1.474h13.282V3.93H99.868z" />
      <filter x="-14.8%" y="-40.7%" width="129.6%" height="262.8%" filterUnits="objectBoundingBox" id="aJ">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aM" d="M86.093 1.474H99.13l-.246 2.457h-13.53z" />
      <filter x="-14.5%" y="-40.7%" width="129%" height="262.8%" filterUnits="objectBoundingBox" id="aL">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aO" d="M72.072 1.474h12.79l-.737 2.457H70.842z" />
      <filter x="-14.3%" y="-40.7%" width="128.5%" height="262.8%" filterUnits="objectBoundingBox" id="aN">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aQ" d="M57.805 1.474h13.283l-1.23 2.457H56.575z" />
      <filter x="-13.8%" y="-40.7%" width="127.6%" height="262.8%" filterUnits="objectBoundingBox" id="aP">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aS" d="M43.784 1.474h12.79l-1.23 2.457H42.063z" />
      <filter x="-13.8%" y="-40.7%" width="127.6%" height="262.8%" filterUnits="objectBoundingBox" id="aR">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aU" d="M29.518 1.474h13.036l-1.72 2.457H27.55z" />
      <filter x="-13.3%" y="-40.7%" width="126.7%" height="262.8%" filterUnits="objectBoundingBox" id="aT">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aW" d="M15.25 1.474H28.29L26.32 3.93H13.037z" />
      <filter x="-13.1%" y="-40.7%" width="126.2%" height="262.8%" filterUnits="objectBoundingBox" id="aV">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="aY" d="M16.48.246h19.68l-.74.983H15.498z" />
      <filter x="-9.7%" y="-101.7%" width="119.4%" height="507%" filterUnits="objectBoundingBox" id="aX">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ba" d="M37.635.246h13.037l-.738.983H36.897z" />
      <filter x="-14.5%" y="-101.7%" width="129%" height="507%" filterUnits="objectBoundingBox" id="aZ">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bc" d="M51.656.246h12.79l-.49.983H50.917z" />
      <filter x="-14.8%" y="-101.7%" width="129.6%" height="507%" filterUnits="objectBoundingBox" id="bb">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="be" d="M65.43.246h12.79l-.245.983H64.94z" />
      <filter x="-15.1%" y="-101.7%" width="130.1%" height="507%" filterUnits="objectBoundingBox" id="bd">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bg" d="M79.205.246h13.037v.983H78.96z" />
      <filter x="-15.1%" y="-101.7%" width="130.1%" height="507%" filterUnits="objectBoundingBox" id="bf">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bi" d="M93.472.246h13.037v.983H93.47z" />
      <filter x="-15.3%" y="-101.7%" width="130.7%" height="507%" filterUnits="objectBoundingBox" id="bh">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bk" d="M107.493.246h13.283v.983h-13.283z" />
      <filter x="-15.1%" y="-101.7%" width="130.1%" height="507%" filterUnits="objectBoundingBox" id="bj">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bm" d="M121.514.246h13.037v.983h-13.036z" />
      <filter x="-15.3%" y="-101.7%" width="130.7%" height="507%" filterUnits="objectBoundingBox" id="bl">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bo" d="M135.29.246h13.035l.246.983h-13.28z" />
      <filter x="-15.1%" y="-101.7%" width="130.1%" height="507%" filterUnits="objectBoundingBox" id="bn">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bq" d="M149.555.246h13.037l.492.983H149.8z" />
      <filter x="-14.8%" y="-101.7%" width="129.6%" height="507%" filterUnits="objectBoundingBox" id="bp">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bs" d="M163.576.246h13.037l.492.983h-13.037z" />
      <filter x="-14.8%" y="-101.7%" width="129.6%" height="507%" filterUnits="objectBoundingBox" id="br">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bu" d="M177.35.246h13.038l.738.983h-13.283z" />
      <filter x="-14.5%" y="-101.7%" width="129%" height="507%" filterUnits="objectBoundingBox" id="bt">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bw" d="M191.372.246h13.037l.737.983H192.11z" />
      <filter x="-14.5%" y="-101.7%" width="129%" height="507%" filterUnits="objectBoundingBox" id="bv">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="by" d="M205.64.246h13.28l.74.983h-13.283z" />
      <filter x="-14.3%" y="-101.7%" width="128.5%" height="507%" filterUnits="objectBoundingBox" id="bx">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bA" d="M51.164 7.126H64.94l-1.576 2.948H49.176z" />
      <filter x="-12.7%" y="-33.9%" width="125.4%" height="235.7%" filterUnits="objectBoundingBox" id="bz">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bC" d="M65.922 7.126h13.775l-.837 2.948H64.672z" />
      <filter x="-13.3%" y="-33.9%" width="126.6%" height="235.7%" filterUnits="objectBoundingBox" id="bB">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bE" d="M80.68 7.126h13.776l-.345 2.948H79.924z" />
      <filter x="-13.8%" y="-33.9%" width="127.5%" height="235.7%" filterUnits="objectBoundingBox" id="bD">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bG" d="M95.44 7.126h14.02l-.098 2.948H95.174z" />
      <filter x="-14%" y="-33.9%" width="128%" height="235.7%" filterUnits="objectBoundingBox" id="bF">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bI" d="M110.445 7.126h14.02l.147 2.948h-14.188z" />
      <filter x="-14.1%" y="-33.9%" width="128.2%" height="235.7%" filterUnits="objectBoundingBox" id="bH">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bK" d="M125.45 7.126h13.774l.393 2.948h-13.942z" />
      <filter x="-14.1%" y="-33.9%" width="128.2%" height="235.7%" filterUnits="objectBoundingBox" id="bJ">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bM" d="M140.454 7.126h13.775l.884 2.948h-14.188z" />
      <filter x="-13.6%" y="-33.9%" width="127.3%" height="235.7%" filterUnits="objectBoundingBox" id="bL">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bO" d="M155.213 7.126h13.775l1.622 2.948h-14.433z" />
      <filter x="-13%" y="-33.9%" width="126%" height="235.7%" filterUnits="objectBoundingBox" id="bN">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bQ" d="M170.218 7.126h13.528l1.87 2.948h-14.19z" />
      <filter x="-13%" y="-33.9%" width="126%" height="235.7%" filterUnits="objectBoundingBox" id="bP">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bS" d="M184.976 7.126h13.53l2.36 2.948h-14.188z" />
      <filter x="-12.6%" y="-33.9%" width="125.2%" height="235.7%" filterUnits="objectBoundingBox" id="bR">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bU" d="M199.98 7.126h24.845l2.706 2.948h-25.6z" />
      <filter x="-7.3%" y="-33.9%" width="114.5%" height="235.7%" filterUnits="objectBoundingBox" id="bT">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bW" d="M4.386 13.27H34.66l-2.437 3.193H1.476z" />
      <filter x="-6%" y="-31.3%" width="112.1%" height="225.2%" filterUnits="objectBoundingBox" id="bV">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="bY" d="M35.732 13.27H50.18l-1.82 3.193H33.7z" />
      <filter x="-12.1%" y="-31.3%" width="124.3%" height="225.2%" filterUnits="objectBoundingBox" id="bX">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
      <path id="ca" d="M51.474 13.27h18.138l-1.083 3.193H49.687z" />
      <filter y="-31.3%" width="120.1%" height="225.2%" filterUnits="objectBoundingBox" id="bZ">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121999547 0" in="shadowBlurOuter1" />
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path d="M31.838 134.897H229.09c1.23 0 2.08.46 2.706 1.23.627.768 26.06 27.48 27.547 29.484 1.725 2.326-.216 4.67-2.706 4.67-85.007 0-169.522-.246-254.56-.246-2.046 0-2.95-2.21-.983-4.668 1.968-2.457 25.908-27.856 26.81-28.75.9-.89 2.213-1.72 3.934-1.72z" fill="#282828" />
      <path d="M.246 169.05s3.198.984 6.395.984c3.2 0 243.767.246 248.44.246 4.674 0 4.92-2.457 4.92-2.457s-.738 4.177-4.92 4.177c-3.745 0-243.273-.246-248.44-.246-5.164 0-6.394-2.703-6.394-2.703z" fill="#000" />
      <path fill="url(#a)" d="M103.065 35.26h61.495v1.72h-61.495z" transform="translate(0 134.897)" />
      <g transform="translate(0 134.897)">
        <use fill="#2D2D2D" xlinkHref="#b" />
        <use fill="#000" filter="url(#c)" xlinkHref="#b" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#282828" xlinkHref="#d" />
        <use fill="#000" filter="url(#e)" xlinkHref="#d" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#f)" xlinkHref="#g" />
        <use fill="#010101" xlinkHref="#g" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#h)" xlinkHref="#i" />
        <use fill="#010101" xlinkHref="#i" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#j)" xlinkHref="#k" />
        <use fill="#010101" xlinkHref="#k" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#l)" xlinkHref="#m" />
        <use fill="#010101" xlinkHref="#m" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#n)" xlinkHref="#o" />
        <use fill="#010101" xlinkHref="#o" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#p)" xlinkHref="#q" />
        <use fill="#010101" xlinkHref="#q" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#r)" xlinkHref="#s" />
        <use fill="#010101" xlinkHref="#s" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#t)" xlinkHref="#u" />
        <use fill="#010101" xlinkHref="#u" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#v)" xlinkHref="#w" />
        <use fill="#010101" xlinkHref="#w" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#x)" xlinkHref="#y" />
        <use fill="#010101" xlinkHref="#y" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#z)" xlinkHref="#A" />
        <use fill="#010101" xlinkHref="#A" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#B)" xlinkHref="#C" />
        <use fill="#010101" xlinkHref="#C" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#D)" xlinkHref="#E" />
        <use fill="#010101" xlinkHref="#E" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#F)" xlinkHref="#G" />
        <use fill="#010101" xlinkHref="#G" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#H)" xlinkHref="#I" />
        <use fill="#010101" xlinkHref="#I" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#J)" xlinkHref="#K" />
        <use fill="#010101" xlinkHref="#K" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#L)" xlinkHref="#M" />
        <use fill="#010101" xlinkHref="#M" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#N)" xlinkHref="#O" />
        <use fill="#010101" xlinkHref="#O" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#P)" xlinkHref="#Q" />
        <use fill="#010101" xlinkHref="#Q" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#R)" xlinkHref="#S" />
        <use fill="#010101" xlinkHref="#S" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#T)" xlinkHref="#U" />
        <use fill="#010101" xlinkHref="#U" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#V)" xlinkHref="#W" />
        <use fill="#010101" xlinkHref="#W" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#X)" xlinkHref="#Y" />
        <use fill="#010101" xlinkHref="#Y" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#Z)" xlinkHref="#aa" />
        <use fill="#010101" xlinkHref="#aa" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#ab)" xlinkHref="#ac" />
        <use fill="#010101" xlinkHref="#ac" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#ad)" xlinkHref="#ae" />
        <use fill="#010101" xlinkHref="#ae" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#af)" xlinkHref="#ag" />
        <use fill="#010101" xlinkHref="#ag" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#ah)" xlinkHref="#ai" />
        <use fill="#010101" xlinkHref="#ai" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aj)" xlinkHref="#ak" />
        <use fill="#010101" xlinkHref="#ak" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#al)" xlinkHref="#am" />
        <use fill="#010101" xlinkHref="#am" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#an)" xlinkHref="#ao" />
        <use fill="#010101" xlinkHref="#ao" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#ap)" xlinkHref="#aq" />
        <use fill="#010101" xlinkHref="#aq" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#ar)" xlinkHref="#as" />
        <use fill="#010101" xlinkHref="#as" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#at)" xlinkHref="#au" />
        <use fill="#010101" xlinkHref="#au" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#av)" xlinkHref="#aw" />
        <use fill="#010101" xlinkHref="#aw" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#ax)" xlinkHref="#ay" />
        <use fill="#010101" xlinkHref="#ay" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#az)" xlinkHref="#aA" />
        <use fill="#010101" xlinkHref="#aA" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aB)" xlinkHref="#aC" />
        <use fill="#010101" xlinkHref="#aC" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aD)" xlinkHref="#aE" />
        <use fill="#010101" xlinkHref="#aE" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aF)" xlinkHref="#aG" />
        <use fill="#010101" xlinkHref="#aG" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aH)" xlinkHref="#aI" />
        <use fill="#010101" xlinkHref="#aI" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aJ)" xlinkHref="#aK" />
        <use fill="#010101" xlinkHref="#aK" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aL)" xlinkHref="#aM" />
        <use fill="#010101" xlinkHref="#aM" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aN)" xlinkHref="#aO" />
        <use fill="#010101" xlinkHref="#aO" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aP)" xlinkHref="#aQ" />
        <use fill="#010101" xlinkHref="#aQ" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aR)" xlinkHref="#aS" />
        <use fill="#010101" xlinkHref="#aS" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aT)" xlinkHref="#aU" />
        <use fill="#010101" xlinkHref="#aU" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aV)" xlinkHref="#aW" />
        <use fill="#010101" xlinkHref="#aW" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aX)" xlinkHref="#aY" />
        <use fill="#010101" xlinkHref="#aY" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#aZ)" xlinkHref="#ba" />
        <use fill="#010101" xlinkHref="#ba" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bb)" xlinkHref="#bc" />
        <use fill="#010101" xlinkHref="#bc" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bd)" xlinkHref="#be" />
        <use fill="#010101" xlinkHref="#be" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bf)" xlinkHref="#bg" />
        <use fill="#010101" xlinkHref="#bg" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bh)" xlinkHref="#bi" />
        <use fill="#010101" xlinkHref="#bi" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bj)" xlinkHref="#bk" />
        <use fill="#010101" xlinkHref="#bk" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bl)" xlinkHref="#bm" />
        <use fill="#010101" xlinkHref="#bm" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bn)" xlinkHref="#bo" />
        <use fill="#010101" xlinkHref="#bo" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bp)" xlinkHref="#bq" />
        <use fill="#010101" xlinkHref="#bq" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#br)" xlinkHref="#bs" />
        <use fill="#010101" xlinkHref="#bs" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bt)" xlinkHref="#bu" />
        <use fill="#010101" xlinkHref="#bu" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bv)" xlinkHref="#bw" />
        <use fill="#010101" xlinkHref="#bw" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bx)" xlinkHref="#by" />
        <use fill="#010101" xlinkHref="#by" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bz)" xlinkHref="#bA" />
        <use fill="#010101" xlinkHref="#bA" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bB)" xlinkHref="#bC" />
        <use fill="#010101" xlinkHref="#bC" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bD)" xlinkHref="#bE" />
        <use fill="#010101" xlinkHref="#bE" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bF)" xlinkHref="#bG" />
        <use fill="#010101" xlinkHref="#bG" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bH)" xlinkHref="#bI" />
        <use fill="#010101" xlinkHref="#bI" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bJ)" xlinkHref="#bK" />
        <use fill="#010101" xlinkHref="#bK" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bL)" xlinkHref="#bM" />
        <use fill="#010101" xlinkHref="#bM" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bN)" xlinkHref="#bO" />
        <use fill="#010101" xlinkHref="#bO" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bP)" xlinkHref="#bQ" />
        <use fill="#010101" xlinkHref="#bQ" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bR)" xlinkHref="#bS" />
        <use fill="#010101" xlinkHref="#bS" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bT)" xlinkHref="#bU" />
        <use fill="#010101" xlinkHref="#bU" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bV)" xlinkHref="#bW" />
        <use fill="#010101" xlinkHref="#bW" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bX)" xlinkHref="#bY" />
        <use fill="#010101" xlinkHref="#bY" />
      </g>
      <g transform="translate(13.037 137.354)">
        <use fill="#000" filter="url(#bZ)" xlinkHref="#ca" />
        <use fill="#010101" xlinkHref="#ca" />
      </g>
      <path d="M37.51.687c-2.86 0-5.178 2.32-5.178 5.18v123.707c0 2.86 2.32 5.18 5.18 5.18h185.213c2.86 0 5.18-2.32 5.18-5.18V5.868c0-2.86-2.32-5.18-5.18-5.18H37.51z" fill="#1D1D1D" />
      <path fill="#474545" d="M39.363 6.217h182.31v123.1H39.364z" />
    </g>
  </g>
)

export default Laptop



// WEBPACK FOOTER //
// ./svg/Laptop.js